import React, {useContext, useState} from 'react';
import "./PinningPage.css"
import {Context} from "../../index";
import cancel from "../../accets/img/cancel.png";
import good from "../../accets/img/Good.png";
import comment from "../../accets/img/comment.png";
import paper_clip from "../../accets/img/paper_clip.png";
import {useNavigate} from "react-router-dom";
import pinning_img from "../../accets/img/pinning_img.png"

const PinningPage = () => {

    const navigate = useNavigate()
    const {taskStore, fileStore, commentStore, statementStore} = useContext(Context)
    const [showPinning, setShowPinning] = useState(false)

    let date = new Intl.DateTimeFormat("ru-RU", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    })

    const TaskWithFileAndComment = taskStore.task.map(task => {
        const withFileId = fileStore.file.filter(file => file['taskId'] === task['id'])
        const file = withFileId.reduce((acc, curr) => {
            acc.push(curr)
            return acc
        }, [])
        const withCommentId = commentStore.comments.filter(comm => comm['taskId'] === task['id'])
        const comm = withCommentId.reduce((acc, curr) => {
            acc.push(curr)
            return acc
        }, [])
        const withSratementId = statementStore.statement.filter(state => state['taskId'] === task['id'])
        const state = withSratementId.reduce((acc, curr) => {
            acc.push(curr)
            return acc
        }, [])
        return {...task, fileto: file, comment: comm, statement: state}
    })

    const visPin = TaskWithFileAndComment.filter(i => i.pinning === true)


    return (
        <div className="pinning__all__block" style={{right: showPinning ? "0" : "-414px"}}>
            <div className="pinning__title__block">
                <div className="pinning__title">
                    <h2>Закрепленные</h2>
                    <div className="arrow" onClick={() => setShowPinning(false)}></div>
                    <div className="show__pinning__block" style={{opacity: showPinning ? "0" : "1"}} onClick={() => setShowPinning(true)}>
                        <img src={pinning_img} alt={pinning_img}/>
                    </div>
                </div>
                <div className="pinning__task__block">

                    {!visPin.length
                        ?
                        <div className="no__pinning__title">Нет еще закрепленных задач</div>
                        :
                        <>
                            {TaskWithFileAndComment.filter(i => i.pinning === true)
                                .sort(({ id: previoudID }, { id: currentID }) => previoudID - currentID)
                                .map(item =>
                                    <div key={item.id} className="one_task one_task_pinning"
                                         onClick={() => navigate(`/job/task/${item.id}`)}>
                                        <div style={{display: 'flex', alignItems: 'center'}}>
                                            <div className="date__block">
                                                <div className="num__block">{item.id}</div>
                                                <div className="date__block">{date.format(Date.parse(item.createdAt))}</div>
                                            </div>
                                            {!item.name
                                                ?
                                                <div className="name__task">Без наименования</div>
                                                :
                                                <div className="name__task">{item.name}</div>
                                            }
                                        </div>
                                        <div>
                                            <div className="com__block">
                                                {item.statement.filter(s => s.status === "NO").map(j =>
                                                    <div key={j.id} className="com">
                                                        <img src={cancel} alt={cancel}/>
                                                    </div>
                                                )

                                                }
                                                {item.statement.filter(s => s.status === "YES").map(j =>
                                                    <div key={j.id} className="com">
                                                        <img src={good} alt={good}/>
                                                    </div>
                                                )

                                                }

                                                {item.comment.length
                                                    ?
                                                    <div className="com">
                                                        <img src={comment} alt={comment}/>
                                                        <div className="com__num">{item.comment.length}</div>
                                                    </div>
                                                    : null
                                                }

                                                {item.fileto.length
                                                    ?
                                                    <div className="paper__clip">
                                                        <img src={paper_clip} alt={paper_clip}/>
                                                    </div>
                                                    : null
                                                }

                                            </div>
                                        </div>
                                    </div>
                                )}

                        </>
                    }




                </div>
            </div>
        </div>
    );
};

export default PinningPage;